import { render } from "./leveltest.vue?vue&type=template&id=8a1da494"
import script from "./leveltest.vue?vue&type=script&lang=js"
export * from "./leveltest.vue?vue&type=script&lang=js"

import "./leveltest.vue?vue&type=style&index=0&id=8a1da494&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__